module.exports = __webpack_public_path__ + "img/mision_fondo.48756eb6.webp";